/* Fine Wines Health — Masterclass registration.

   Answers "where are the masterclass signups going?": they go to the Klaviyo list below
   and nowhere else. Community Members (Xw2kH9) and Newsletter (QSGAWs) are deliberately
   NOT touched here, so masterclass interest stays separable from community joins.
   (A Klaviyo flow copies masterclass registrants into Newsletter afterwards.)

   Sep 2026: also passes an ISO start time (masterclass_starts_at), derived from the
   date and time lines in the theme customizer, so Klaviyo can schedule the day-before
   and morning-of reminder emails automatically. The Zoom link and an exact start time
   can also be set per session in the Community section settings (data-mc-zoom,
   data-mc-starts); if the Zoom field is blank the Klaviyo templates use the standing link.

   Uses the PUBLIC Klaviyo company id only. No private key in the theme. */
(function () {
  var COMPANY_ID = 'UCVYtc';
  var LIST_ID = 'XeZahd';               // Audacity of Midlife Masterclass
  var METRIC = 'Registered for Masterclass';
  var REV = '2024-10-15';

  /* Turn the customizer's display strings ("Saturday, October 18, 2026" + "10:00 AM EST")
     into an ISO start time in US Eastern, e.g. 2026-10-18T10:00:00-04:00. Klaviyo stores
     that as a date property and schedules the day-before / morning-of reminders from it.
     Returns '' if the date cannot be read, in which case reminders simply do not fire. */
  var MONTHS = { jan:0, feb:1, mar:2, apr:3, may:4, jun:5, jul:6, aug:7, sep:8, oct:9, nov:10, dec:11 };
  function toIsoEastern(dateStr, timeStr) {
    var s = String(dateStr || '').trim();
    if (!s) return '';
    var y, mo, d, m;
    if ((m = s.match(/([A-Za-z]{3,9})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/))) {          // October 18, 2026
      mo = MONTHS[m[1].slice(0, 3).toLowerCase()]; d = +m[2]; y = +m[3];
    } else if ((m = s.match(/(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3,9})\.?,?\s+(\d{4})/))) {   // 18 October 2026
      d = +m[1]; mo = MONTHS[m[2].slice(0, 3).toLowerCase()]; y = +m[3];
    } else if ((m = s.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/))) {                                // 10/18/2026 (US)
      mo = +m[1] - 1; d = +m[2]; y = +m[3];
    } else if ((m = s.match(/(\d{4})-(\d{2})-(\d{2})/))) {                                       // 2026-10-18
      y = +m[1]; mo = +m[2] - 1; d = +m[3];
    }
    if (mo === undefined || isNaN(mo) || !d || !y) return '';

    var hh = 12, mm = 0;                                                                        // noon if no time given
    var t = String(timeStr || '').match(/(\d{1,2})(?::(\d{2}))?\s*([AaPp])\.?\s*[Mm]?/);
    if (t) {
      hh = +t[1] % 12; if (/p/i.test(t[3])) hh += 12; mm = t[2] ? +t[2] : 0;
    } else if ((t = String(timeStr || '').match(/(\d{1,2}):(\d{2})/))) {
      hh = +t[1]; mm = +t[2];
    }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var wall = y + '-' + pad(mo + 1) + '-' + pad(d) + 'T' + pad(hh) + ':' + pad(mm) + ':00';

    var offset = '-05:00';                                                                      // EST
    try {                                                                                       // EDT if that date is in daylight time
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', timeZoneName: 'short' })
        .formatToParts(new Date(Date.UTC(y, mo, d, 16, 0, 0)));
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'timeZoneName' && /EDT/.test(parts[i].value)) offset = '-04:00';
      }
    } catch (err) {}
    return wall + offset;
  }

  /* The customizer's optional "exact start time" field. A full ISO value with an offset
     is used as is; anything else ("2026-10-03 10:00 AM") is read as US Eastern. */
  function normStarts(v) {
    v = String(v || '').trim();
    if (!v) return '';
    if (/T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(v)) return v;
    return toIsoEastern(v, v);
  }

  function init() {
    var modal = document.getElementById('masterclass-modal');
    var triggers = document.querySelectorAll('.masterclass-trigger');
    if (!modal || !triggers.length) return;

    var form = document.getElementById('masterclass-form');
    var wrap = document.getElementById('masterclass-form-wrap');
    var titleEl = modal.querySelector('[data-mc-title]');
    var whenEl = modal.querySelector('[data-mc-when]');
    var noteField = modal.querySelector('[data-mc-note-field]');
    var session = {};

    function open(e) {
      if (e) e.preventDefault();
      var t = e && e.currentTarget ? e.currentTarget : null;
      session = {
        name: (t && t.getAttribute('data-mc-session')) || 'The Audacity of Midlife',
        date: (t && t.getAttribute('data-mc-date')) || '',
        time: (t && t.getAttribute('data-mc-time')) || '',
        place: (t && t.getAttribute('data-mc-place')) || '',
        zoom: (t && t.getAttribute('data-mc-zoom')) || '',      // joining link (from theme setting)
        starts: normStarts(t && t.getAttribute('data-mc-starts')), // optional override; derived below if absent
        source: (t && t.getAttribute('data-mc-source')) || 'Website'
      };
      if (!session.starts) session.starts = toIsoEastern(session.date, session.time);
      if (titleEl) titleEl.textContent = session.name;
      if (whenEl) {
        whenEl.textContent = [session.date, session.time, session.place]
          .filter(Boolean).join('  \u00b7  ');
      }
      modal.classList.add('modal-overlay--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = modal.querySelector('.modal-input');
      if (first) setTimeout(function () { first.focus(); }, 100);
    }

    function close() {
      modal.classList.remove('modal-overlay--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    triggers.forEach(function (btn) { btn.addEventListener('click', open); });

    var closeBtn = modal.querySelector('.modal-close');
    var backdrop = modal.querySelector('.modal-backdrop');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('masterclass-form-submit');
      var val = function (n) {
        var el = form.querySelector('[name="contact[' + n + ']"]');
        return el ? el.value.trim() : '';
      };
      var email = val('email');
      if (!email) return;

      var first = val('first_name'), last = val('last_name');
      var phone = val('phone'), interest = val('interest');

      // Profile properties: the reminder flow reads these (it has no event to look at).
      var props = {
        '$first_name': first,
        '$last_name': last,
        signup_source: session.source,
        masterclass_session: session.name,
        masterclass_date: session.date,
        masterclass_time: session.time,
        masterclass_interest: interest,
        registered_at: new Date().toISOString()
      };
      if (phone) props.phone = phone;   // property, not phone_number: avoids strict E.164 validation
      if (session.zoom) props.masterclass_zoom = session.zoom;
      if (session.starts) props.masterclass_starts_at = session.starts;   // date property: drives reminders

      // 1. Subscribe to the masterclass list only.
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
          method: 'POST', keepalive: true,
          headers: { 'revision': REV, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Masterclass: ' + session.source,
                profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
              },
              relationships: { list: { data: { type: 'list', id: LIST_ID } } }
            }
          })
        });
      } catch (err) {}

      // 2. Fire the event that triggers the confirmation flow. Event properties are what
      //    the confirmation email reads ({{ event.session }}, {{ event.zoom }}, ...).
      var eventProps = {
        session: session.name, date: session.date, time: session.time,
        place: session.place, source: session.source, interest: interest
      };
      if (session.zoom) eventProps.zoom = session.zoom;
      if (session.starts) eventProps.starts_at = session.starts;

      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID, {
          method: 'POST', keepalive: true,
          headers: { 'revision': REV, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                metric: { data: { type: 'metric', attributes: { name: METRIC } } },
                properties: eventProps,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email, properties: { '$first_name': first, '$last_name': last } }
                  }
                }
              }
            }
          })
        });
      } catch (err) {}

      // 3. Also record in Shopify, tagged masterclass so it never mixes with community.
      if (noteField) {
        noteField.value = [session.name, session.date, session.time, 'via ' + session.source,
                           interest ? 'Wants covered: ' + interest : ''].filter(Boolean).join(' | ');
      }
      var data = new FormData(form);
      data.set('form_type', 'customer');
      data.set('utf8', '\u2713');
      data.delete('contact[interest]');   // not a Shopify customer field

      if (btn) { btn.disabled = true; btn.textContent = 'Reserving\u2026'; }

      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST', body: data, headers: { 'Accept': 'application/json' }
      }).catch(function () {}).then(function () {
        if (wrap) {
          wrap.innerHTML =
            '<p class="modal-pretitle">You are registered</p>' +
            '<h2 class="modal-title">See you there.</h2>' +
            '<p class="modal-subtitle">Your confirmation and Zoom link are on their way to ' + email +
            '. We will remind you the day before.</p>';
        }
        setTimeout(close, 2600);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
